
import gql from 'graphql-tag';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import shortTermSavPlanScenariosQuery from '~/apollo/queries/product/shortTermSavPlanScenario.gql';
import shortTermsSavTooltips from '~/apollo/queries/product/tooltips/shortTermsSavTooltips';
import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productShortcutMixins from "~/mixins/productShortcutMixins.js";
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [commonProductDetailMixins, productPromotionMixins, productShortcutMixins, productInsuranceNameMixins],

  data() {
    return {
      shortTermSavPlanScenarios: null,
      loading: 0,
      year: this.$route.query.year || null,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
  // page component definitions
  apollo: {
    $loadingKey: 'loading',
    shortTermSavPlanScenarios: {
      query: gql`
        ${shortTermSavPlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        return {
          scenario_code: this.$route.params.slug,
          locale: this.currentLocale,
          // year: parseInt(this.year),
        };
      },
    },
    shortTermsSavTooltips: {
      query: shortTermsSavTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  computed: {
    simpleItems() {
      if (this.shortTermSavPlanScenarios?.data[0]) {
        const item = this.shortTermSavPlanScenarios.data[0];
        const year = this.year?this.year:(item.attributes.maturity<=8?item.attributes.maturity:8);
        // let promotionPrices = Array;
        // promotionPrices = [];

        let promotions = null;
        let promotion = null;
        let promotion_last_call = null;

        const planName =
          item.attributes.short_term_sav_plan.data.attributes.short_term_sav_plan_translations.data[0].attributes.name;
          const insurer = item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
        let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.shortSavings.st_categoryName'), insurer, planName);
        let decoderCTAText = '';
        let hide = Boolean;
        hide = false;

        const shortcut = this.getProductShortcut(item.attributes);

        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.short_term_sav_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.short_term_sav_plan.data.attributes.product_promotions.data;
        }

        if(promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          promotion_last_call = this.checkPromotionLastCall(promotion);

          if (!promotion) {
            promotion = null;
          } else if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
            decoderCTALink = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
            decoderCTAText = this.$t('products.product_website');
            const translation = promotion.attributes.product_promotion_translations?.data[0];
            hide = translation.attributes?.HideBanner;
          }
        }

        const filteredTranslations = this.getFilteredTranslations(item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
        .insurance_company_translations.data[0].attributes.localizations.data);

        return {
          scenario_code: item.attributes.scenario_code,
          payment_term: item.attributes.premium_term,
          rating: item.attributes.rating,
          currency_code: item.attributes.currency.data.attributes.code,
          currency: item.attributes.currency.data.attributes.currency_translations.data[0].attributes,

          min_total_premium: item.attributes.min_total_premium,
          max_total_premium: item.attributes.max_total_premium,
          maturity: item.attributes.maturity,
          gbey: item.attributes.gbey,

          plan_name: planName,
          death_benefit:
            item.attributes.short_term_sav_plan.data.attributes.short_term_sav_plan_translations.data[0].attributes
              .death_benefit,
          online_purchase: item.attributes.short_term_sav_plan.data.attributes.online_purchase,
          issue_age_from: item.attributes.short_term_sav_plan.data.attributes.issue_age_from,
          issue_age_to: item.attributes.short_term_sav_plan.data.attributes.issue_age_to,

          insurer_name_first:
            item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data
              .attributes.insurance_company_translations.data[0].attributes.name,
          insurer_name_second:
            filteredTranslations[0].attributes.name,
          insurer_logo:
            item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data
              .attributes.logo,
          insurer_code:
            item.attributes.short_term_sav_plan.data.attributes.product.data.attributes.insurance_company.data
              .attributes.code,

          financial_result_year1: item.attributes.short_term_sav_fins.data.filter(
            (dataItem) => dataItem.attributes.year === 1
          ),
          financial_result_maturity: item.attributes.short_term_sav_fins.data.filter(
            (dataItem) => dataItem.attributes.year === parseInt(year)
          ),
          financial_result_all: item.attributes.short_term_sav_fins.data,
          product_promotion: promotion,
          decoder_cta_link: decoderCTALink,
          decoder_cta_text: decoderCTAText,
          promotion_last_call: promotion_last_call,

          scenarioId: item.id,
          hide,
          shortcut: shortcut,
          year,
        };
      }
      return null;
    },

    product() {
      if (!this.simpleItems) return null;
      const item = this.simpleItems;
      return {
        highlightSection: {
          scenarioCode: item.scenario_code,
          scenarioId: item.scenarioId,
          showFiveStarBadge: parseInt(item.overall_star) === 5,
          productName: item.plan_name,
          insuranceCompany: {
            name: item.insurer_name_first + ' | ' + item.insurer_name_second,
            code: item.insurer_code,
            logoSrc: item.insurer_logo?.data?.attributes?.url,
            logoAlt: item.insurer_name_first,
          },
          userRating: {
            score: item.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(item)),
            description: this.$t('products.shortSavings.st_shortTermSavingsScore'),
            toolTipHtml: this.getTooltipContentByKey('st_shortTermSavingsScore'),
          },
          features: [
            {
              text: this.getCurrency(item.currency),
              type: 'currency',
            },
            {
              text:
                parseInt(item.payment_term) === 1
                  ? this.$t('products.prepaid')
                  : item.payment_term + this.$t('products.shortSavings.st_yearpayment'),
              type: 'payment_term',
            },
            {
              text: item.maturity + this.$t('products.shortSavings.st_yearmaturity'),
              type: 'target_period',
            },
          ],
          keyItems: [
            {
              value: this.$formatPercentageDP(item.financial_result_maturity[0].attributes.guarantee_irr_surrender, 2),
              key: this.getReturnRatioLabel(
                item.year,
                this.$t('products.shortSavings.st_targetPeriodGuaranteedIRR')
              ),
              topSubText: '',
              toolTipHtml: this.getTargetPeriodGuaranteedIRRTooltip(item.year),
              symbolValue: '',
              originalValue: '',
            },
            {
              // value: (item.gbey > 1)? item.gbey + " " + this.$t('products.yearsUnit') : item.gbey + " " + this.$t('products.yearUnit'),
              value: item.gbey > 0 ? item.gbey : this.$t('products.shortSavings.st_gbey_immediate'),
              key: this.$t('products.shortSavings.st_guaranteedBreakeven'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatPrice(item.min_total_premium),
              key: this.$t('products.shortSavings.st_minimumTotalPremium'),
              topSubText: item.currency_code,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
            },
          ],
          mainButtonCTA: {
            text: item.decoder_cta_text,
            link: item.decoder_cta_link,
          },
          showShortcut: this.simpleItems.shortcut,
        },
        detailSection: {
          details: [
            {
              id: 0,
              sectionTitle: this.$t('products.shortSavings.st_overview'),
              keyValues: [
                {
                  key: this.$t('products.shortSavings.st_shortTermSavingsScore'),
                  value: this.getScore(item) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_currency'),
                  value: this.getCurrency(item.currency),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.paymentTerm'),
                  value:
                    parseInt(item.payment_term) === 1
                      ? this.$t('products.prepaid')
                      : item.payment_term + this.$t('products.shortSavings.st_yearpayment'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_policyTerm'),
                  value: item.maturity + ' ' + this.$t('products.yearUnit'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_issueAge'),
                  value: this.$formatAgeRange(
                    this.currentLocale,
                    item.issue_age_from,
                    item.issue_age_to,
                    this.$t('products.ageUnit'),
                    this.$t('products.to')
                  ),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_minimumTotalPremium'),
                  value:
                    item.min_total_premium > 0
                      ? item.currency_code + ' ' + this.$formatPrice(item.min_total_premium)
                      : this.$t('products.not_specified'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_maximumTotalPremium'),
                  value:
                    item.max_total_premium > 0
                      ? item.currency_code + ' ' + this.$formatPrice(item.max_total_premium)
                      : this.$t('products.not_specified'),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_onlinePurchase'),
                  value: item.online_purchase,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.shortSavings.st_deathBenefit'),
                  value: item.death_benefit,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 1,
              sectionTitle: this.$t('products.shortSavings.st_guaranteedReturn'),
              keyValues: this.girrKVs(item),
            },
          ],
          promotion: {
            category:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes?.PromotionCategory,
            title:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes?.PromotionTitle,
            ctaButtonLink:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes?.CTAButtonLink,
            ctaButtonText:
              item.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes?.CTAButtonText,
            promotionId: item.product_promotion?.id,
            scenarioId: item.scenarioId,
            hide: item.hide,
            lastCall: item.promotion_last_call

          },
        },
      };
    },
  },

  methods: {
    getCurrency(curr) {
      if (this.currentLocale === 'zh-Hant-HK') {
        return curr.text;
      } else {
        return curr.localizations.data[0].attributes.text;
      }
    },

    getScore(product) {
      // console.log(product.financial_result_maturity[0]);
      return this.$formatScore(
        product.financial_result_maturity[0].attributes.rating
          ? product.financial_result_maturity[0].attributes.rating
          : 0,
        2
      );
    },

    getReturnRatioLabel(index, label) {
      if (this.currentLocale === 'en') {
        return label.replace('$num', this.$ordinalSuffix(index));
      } else if (this.currentLocale === 'zh-Hant-HK') {
        return label.replace('$num', index);
      }
    },

    girrKVs(item) {
      const girrMaturityKVs = (index) => {
        let tmpFin = null;
        tmpFin = item.financial_result_all.filter((fin) => {
          return fin.attributes.year <= item.maturity;
        });
        return tmpFin.map((fin) => ({
          key: fin.attributes.year + ' ' + this.$t('products.yearUnit'),
          value: this.$formatPercentageDP(fin.attributes.guarantee_irr_surrender, index),
          keyToolTipHtml: '',
          expandableKeyValues: [],
        }));
      };

      const grrKVs = (index) => {
        let tmpFin = null;
        tmpFin = item.financial_result_all.filter((fin) => {
          return fin.attributes.year <= item.maturity;
        });
        return tmpFin.map((fin) => ({
          key: fin.attributes.year + ' ' + this.$t('products.yearUnit'),
          value: this.$formatPercentageDP(fin.attributes.guarantee_return_ratio, index),
          keyToolTipHtml: '',
          expandableKeyValues: [],
        }));
      };

      const firstArray = [
        {
          key: this.$t('products.shortSavings.st_guaranteedIRREarlySurrenderoratMaturity'),
          value: '',
          keyToolTipHtml: this.getTargetPeriodGuaranteedIRRTooltip(item.maturity),
          expandableKeyValues: [],
        },
      ];
      const secondArray = girrMaturityKVs(2);
      const thirdArray = [
        {
          key: this.$t('products.shortSavings.st_guaranteedReturnRatioGuaranteedBenefitPremiumPaid'),
          value: '',
          keyToolTipHtml: '',
          expandableKeyValues: grrKVs(1),
        },
      ];

      return firstArray.concat(secondArray.concat(thirdArray));
    },

    getTooltipContentByKey(mKey) {
      return this.shortTermsSavTooltips?.ShortTermSav?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getTargetPeriodGuaranteedIRRTooltip(maturity) {
      const tooltip = this.getTooltipContentByKey('st_targetPeriodGuaranteedIRR');
      const maturityValue = maturity.toString();
      const processedMaturityYearValue =
        this.currentLocale === 'zh-Hant-HK' ? maturityValue : this.$ordinalSuffix(parseInt(maturityValue));
      return tooltip?.replace('{replace_year}', processedMaturityYearValue);
    },
  },
};
